import { Icon } from "@iconify/react";

/**
 * A compact "+ Add" trigger row — icon, title, one-line description, and an
 * "+ Add" action on the right — that opens an upload modal on click. Same
 * markup DiagnosticsImagingView.tsx originally used for its own DICOM
 * trigger, extracted here so the Upload Records page's two entry points
 * (Medical Records, DICOM) share one implementation instead of two copies
 * of the same card.
 */
export function UploadEntryCard({
  icon,
  title,
  description,
  onClick,
}: {
  icon: string;
  title: string;
  description: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center justify-between gap-3 rounded-xl border border-[#E5E7EB] bg-white px-6 py-7 text-left shadow-sm transition-shadow hover:shadow-md"
    >
      <span className="flex items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#E4002B]/50">
          <Icon icon={icon} className="h-4 w-4 !text-white" />
        </span>
        <span>
          <span className="block text-sm font-extrabold uppercase tracking-wide text-[#0A2947]">{title}</span>
          <span className="mt-0.5 block text-xs font-medium normal-case tracking-normal text-[#9CA3AF]">
            {description}
          </span>
        </span>
      </span>
      <span className="flex shrink-0 items-center gap-1 text-sm font-extrabold text-[#E4002B]">
        <Icon icon="lucide:plus" className="h-4 w-4 !text-[#E4002B]" />
        Add
      </span>
    </button>
  );
}
